import { render, staticRenderFns } from "./exhibition-activity-mes.vue?vue&type=template&id=f13835e4&scoped=true&"
import script from "./exhibition-activity-mes.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-mes.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-mes.vue?vue&type=style&index=0&id=f13835e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13835e4",
  null
  
)

export default component.exports